import {
  CheckArgumentsTemplateListView,
  type CheckArgumentsTemplateListConfig,
} from "../check-arguments-templates-shared";

const config: CheckArgumentsTemplateListConfig = {
  listApiPath:
    "/api/internal/client-portal/check-arguments-templates/civil-litigation/",
  settingsPathPrefix: "civil-litigation-templates",
  pageTitle: (t) => t("Civil Litigation Templates"),
  testIdPrefix: "civil-litigation-template",
  apiPathPrefix: "civil-litigation",
  filterBarTestId: "civil-litigation",
};

export const CivilLitigationTemplateListView =
  CheckArgumentsTemplateListView(config);
